import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'


import { Home } from './home/Home';
import { SiteFooter } from './SiteFooter'
import { About } from './About'

import logo from './images/bb_pinkorange.png';

class App extends Component {
  render() {
    const aboutActive = window.location.href.includes('about')
    return (
      <div>
        <header className="bg-white tc pv4 avenir orange-bg light-pink-text">
          <img src={logo} className="h4 app-logo" alt="logo" />
          <h2 className="mt4 mb0 f6 fw4 ttu tracked">Outspoken Vintage & Homeware</h2>
          <nav className="bt bb tc mw7 center mt4">
            <a className={"f6 f5-l link bg-animate hover-bg-bandb-pink dib pa3 ph4-l light-pink-text " + (!aboutActive ? 'hover-bandb-pink-active' : '')} href="/">Home</a>
            <a className={"f6 f5-l link bg-animate hover-bg-bandb-pink dib pa3 ph4-l light-pink-text "} target="_blank" rel="noopener noreferrer" href="https://www.etsy.com/shop/beauandbadger">Shop</a>
            <a className={"f6 f5-l link bg-animate hover-bg-bandb-pink dib pa3 ph4-l light-pink-text " + (aboutActive ? 'hover-bandb-pink-active' : '')} href="/about">About</a>
            <a className={"f6 f5-l link bg-animate hover-bg-bandb-pink dib pa3 ph4-l light-pink-text "} href="mailto:beauandbadger@gmail.com">Contact</a>
          </nav>
        </header>
        <article>
          <Router>
            <div>
              <Route exact path="/" component={Home} />
              <Route exact path="/about" component={About} />
            </div>
          </Router>
        </article>
        <SiteFooter>
        </SiteFooter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js